var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedbackParchment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "367px",
    height: "689px",
    viewBox: "0 0 367 689",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "svg/Feedback-parchment") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), /*#__PURE__*/React.createElement("g", {
    id: "Feedback-parchment",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SHADOW",
    transform: "translate(6.000000, 6.000000)",
    fill: "#000000",
    opacity: 0.3,
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.7,231.8 C256.4,234.4 258.7,238.3 258.8,239.2 C258.4,241.7 255,241.8 253.2,245.6 C252.317331,247.453605 252.291677,249.38512 252.435347,250.706855 C255.838169,250.678432 259.292608,250.65147 262.783072,250.619899 C261.96989,246.319678 260.8,242.9 260.8,242.9 C260.8,242.9 257.3,234.8 254.7,231.8 Z M275.479413,678.695 L275.661274,678.768101 C275.906926,678.862381 276.153191,678.940426 276.4,679 L272.5,678.9 C273.195,678.8425 273.89125,678.791875 274.588678,678.7477 L275.479413,678.695 Z M83.5029149,269.172806 L83.4483092,269.173327 C82.6291534,269.198817 81.8271265,269.276923 81.0585995,269.4 C73.2324327,270.6 66.6551223,285.2 75.9799168,296.8 C78.9771721,300.6 83.9725977,302.3 88.5517379,300.8 C88.8847662,300.7 95.6285908,298.4 97.7932752,290.2 C99.0940843,285.187299 98.0661194,280.556019 97.0523393,277.685633 C92.15876,285.638034 84.0789916,287.729412 74.6,277 C74.6,277 74.9,270.6 83,269.4 C83.1498934,269.376939 83.3197289,269.296712 83.5029149,269.172806 Z M256.058599,268.4 C248.232433,269.6 241.655122,284.2 250.979917,295.8 C253.977172,299.6 258.972598,301.3 263.551738,299.8 C263.884766,299.7 270.628591,297.4 272.793275,289.2 C274.000876,284.54648 273.201479,280.221679 272.269621,277.329275 C267.398823,285.572979 259.219992,287.889012 249.6,277 C249.6,277 249.9,270.6 258,269.4 C258.416507,269.335922 258.986988,268.83045 259.570026,268.172998 C258.364354,268.136866 257.178029,268.220727 256.058599,268.4 Z M79.7,231.8 C81.4,234.4 83.7,238.3 83.8,239.2 C83.4,241.7 80,241.8 78.2,245.6 C77.2233482,247.650969 77.29593,249.797322 77.4861673,251.107483 C79.2065528,251.085852 80.9436364,251.051227 82.7,251 C83.2392785,250.935287 85.1419272,250.875226 87.8217646,250.820823 C87.0067074,246.427299 85.8,242.9 85.8,242.9 C85.8,242.9 82.3,234.8 79.7,231.8 Z M93.1594127,224.165 L93.156222,224.207534 L93.1554127,224.213 L93.1564127,224.207 L93.1564127,224.206 L93.1594127,224.171 L93.1594127,224.165 Z M87.7,0 C88.2666667,29.3148438 89,48.305599 89.9,56.9722656 C91.2365,69.8422656 92.08295,104.764516 92.0997454,114.436939 L92.100392,115.119742 C92.1131987,122.121061 92.439768,154.07365 93.0801,210.977509 L93.1,212.745011 L78.2,213.745011 C77.8666667,180.096514 78.0666667,153.605599 78.8,134.272266 C79.526,115.132266 78.2918,74.7137586 75.0974,13.0167446 L75,11.140625 L87.7,0 Z M262.7,0 C263.266667,29.3148438 264,48.305599 264.9,56.9722656 C266.2365,69.8422656 267.08295,104.764516 267.099745,114.436939 L267.100392,115.119742 C267.113199,122.121061 267.439768,154.07365 268.0801,210.977509 L268.1,212.745011 L253.2,213.745011 C252.866667,180.096514 253.066667,153.605599 253.8,134.272266 C254.526,115.132266 253.2918,74.7137586 250.0974,13.0167446 L250,11.140625 L262.7,0 Z M268.155413,224.213 L268.156413,224.207 L268.156413,224.206 L268.159413,224.171 L268.159413,224.165 L268.156222,224.207534 L268.155413,224.213 Z M254.7,231.8 C261.481034,231.210345 266.909929,226.66085 267.095116,226.504146 L267.1,226.5 C272.722929,233.199088 275.75457,241.874213 276.724609,250.459215 C278.994049,250.42579 281.271085,250.387528 283.550496,250.343274 C283.395715,246.61764 282.594377,241.829363 280.1,236.9 C277.3,231.3 272,225.4 268.1,224.9 L268.103413,224.849 L268.107413,224.799 L268.135413,224.46 L268.143413,224.36 L268.150413,224.274 L268.142641,224.360188 C268.128571,224.514966 268.114286,224.661905 268.1,224.8 C265,227.7 262.3,229.6 258.4,230.8 C254.3,232 252.3,231.5 251.3,231.2 C249,227.7 247.2,218.2 252.9,215.2 C257.8,213.3 266.1,213 267,213.7 C268.497619,214.933333 268.443084,220.357483 268.203768,223.61416 L268.183413,223.873 L268.234375,223.265625 C268.35625,221.64375 268.45,220.05 268.6,218.4 C269.7,218.3 271.3,218.1 273.2,218.2 C276,218.3 283.3,218.4 288.4,223 C295.464392,229.269648 295.666759,240.607835 295.135464,250.059907 C312.088238,249.55067 328.795835,248.582324 343.6,246.6 C345.2,276 347.9,307.9 349.7,337.5 C349.4,347.8 348.1,342.8 340.5,353.5 C340.7,358 341.9,359.6 344.8,365.7 C351.1,415.3 346.1,471.4 349.4,522 C353.1,563.9 351.7,619.4 358,661 C358.4,665.4 360.8,674.5 357.3,677.8 C331.12,685.01875 302.531344,677.229719 275.635695,678.686222 L275.479413,678.695 C270.079624,676.444713 264.986979,666.607531 260.93764,672.976561 L260.8,673.2 C243.6,682.4 222.8,680 203.7,681 C162.7,681.3 121.3,678 80.3,678.3 C69.8,675.9 69.7,661.2 60.6,676 C43.2,677.3 23,674.7 5.4,675.4 C1.4,657.5 6.2,636 5.1,618 C3.7,596.3 0.4,562.8 1.9,540.9 C-0.548979592,529.242857 0.840441483,521.999875 2.77820551,511.180914 L2.9,510.5 L1,498.5 C3.7,495.4 6.3,494.5 7.2,490.5 C0.5,484.8 1.6,480.6 2.2,473.2 C3.3,455.2 1.9,436.6 3.8,417.3 C8.8,388.5 4.7,359.3 14.7,332.9 C9.1,328.9 5.6,323.7 5.7,316.5 C5.2,303.8 2.5,293.6 4.4,280.3 C6.7,270.2 2,253.4 14.8,252.1 C33.4067493,249.883026 50.0700772,250.925984 68.1156811,251.108981 C67.5705706,251.069778 67.0326797,251.032284 66.5,251 C64.1,245.2 68.2,237.3 68.5,236.9 C69.9,234.7 72.2,231.6 74.9,231.2 C75.5,231.8 77.9,232.7 79.7,231.8 C86.4810345,231.210345 91.9099287,226.66085 92.0951161,226.504146 L92.1,226.5 C97.7604895,233.243837 100.794957,241.990199 101.743772,250.631243 C104.075137,250.60803 106.395878,250.587567 108.559926,250.570135 C108.427658,246.81265 107.645185,241.929771 105.1,236.9 C102.3,231.3 97,225.4 93.1,224.9 L93.1034127,224.849 L93.1074127,224.799 L93.1354127,224.46 L93.1434127,224.36 L93.1504127,224.274 L93.1426412,224.360188 C93.1285714,224.514966 93.1142857,224.661905 93.1,224.8 C90,227.7 87.3,229.6 83.4,230.8 C79.3,232 77.3,231.5 76.3,231.2 C74,227.7 72.2,218.2 77.9,215.2 C82.8,213.3 91.1,213 92,213.7 C93.497619,214.933333 93.4430839,220.357483 93.2037685,223.61416 L93.1834127,223.873 L93.234375,223.265625 C93.35625,221.64375 93.45,220.05 93.6,218.4 C94.7,218.3 96.3,218.1 98.2,218.2 C101,218.3 108.3,218.4 113.4,223 C120.573512,229.366492 120.671374,240.959317 120.110341,250.496538 L119.7,250.5 C155.8,250.1 192.2,251.7 228.3,251 C232.516163,250.914206 236.903573,250.853949 241.421541,250.805604 L241.5,251 C239.1,245.2 243.2,237.3 243.5,236.9 C244.9,234.7 247.2,231.6 249.9,231.2 C250.5,231.8 252.9,232.7 254.7,231.8 Z",
    id: "Combined-Shape",
    style: {
      mixBlendMode: "multiply"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Feedback_modal"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343.6,246.6 C345.2,276 347.9,307.9 349.7,337.5 C349.4,347.8 348.1,342.8 340.5,353.5 C340.7,358 341.9,359.6 344.8,365.7 C351.1,415.3 346.1,471.4 349.4,522 C353.1,563.9 351.7,619.4 358,661 C358.4,665.4 360.8,674.5 357.3,677.8 C331.12,685.01875 302.531344,677.229719 275.635695,678.686222 L275.479413,678.695 C270.079624,676.444713 264.986979,666.607531 260.93764,672.976561 L260.8,673.2 C243.6,682.4 222.8,680 203.7,681 C162.7,681.3 121.3,678 80.3,678.3 C69.8,675.9 69.7,661.2 60.6,676 C43.2,677.3 23,674.7 5.4,675.4 C1.4,657.5 6.2,636 5.1,618 C3.7,596.3 0.4,562.8 1.9,540.9 C-0.548979592,529.242857 0.840441483,521.999875 2.77820551,511.180914 L2.9,510.5 L1,498.5 C3.7,495.4 6.3,494.5 7.2,490.5 C0.5,484.8 1.6,480.6 2.2,473.2 C3.3,455.2 1.9,436.6 3.8,417.3 C8.8,388.5 4.7,359.3 14.7,332.9 C9.1,328.9 5.6,323.7 5.7,316.5 C5.2,303.8 2.5,293.6 4.4,280.3 C6.7,270.2 2,253.4 14.8,252.1 C38.3,249.3 58.7,251.7 82.7,251 C85.0989899,250.712121 114.478135,250.516325 119.234063,250.500973 L119.7,250.5 C155.8,250.1 192.2,251.7 228.3,251 C262.7,250.3 308.5,251.3 343.6,246.6 Z M275.479413,678.695 L275.661274,678.768101 C275.906926,678.862381 276.153191,678.940426 276.4,679 L272.5,678.9 C273.195,678.8425 273.89125,678.791875 274.588678,678.7477 L275.479413,678.695 Z M81.0585995,269.4 C73.2324327,270.6 66.6551223,285.2 75.9799168,296.8 C78.9771721,300.6 83.9725977,302.3 88.5517379,300.8 C88.8847662,300.7 95.6285908,298.4 97.7932752,290.2 C99.7914455,282.5 96.2946475,275.7 95.795105,274.8 C92.4648212,269.7 86.0540251,268.6 81.0585995,269.4 Z M256.058599,268.4 C248.232433,269.6 241.655122,284.2 250.979917,295.8 C253.977172,299.6 258.972598,301.3 263.551738,299.8 C263.884766,299.7 270.628591,297.4 272.793275,289.2 C274.791445,281.5 271.294648,274.7 270.795105,273.8 C267.381564,268.7 261.054025,267.6 256.058599,268.4 Z",
    id: "background",
    fill: "#A1D0D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.5,678.9 C300.3,676.6 330.1,685.3 357.3,677.8 C360.8,674.5 358.4,665.4 358,661 C351.7,619.4 353.1,563.9 349.4,522 C346.1,471.4 351.1,415.3 344.8,365.7 C341.9,359.6 340.7,358 340.5,353.5 C348.1,342.8 349.4,347.8 349.7,337.5 C347.9,307.9 345.2,276 343.6,246.6 C308.5,251.3 262.7,250.3 228.3,251 C192.2,251.7 155.8,250.1 119.7,250.5 C117,250.5 85.2,250.7 82.7,251 C58.7,251.7 38.3,249.3 14.8,252.1 C2,253.4 6.7,270.2 4.4,280.3 C2.5,293.6 5.2,303.8 5.7,316.5 C5.6,323.7 9.1,328.9 14.7,332.9 C4.7,359.3 8.8,388.5 3.8,417.3 C1.9,436.6 3.3,455.2 2.2,473.2 C1.6,480.6 0.5,484.8 7.2,490.5 C6.3,494.5 3.7,495.4 1,498.5 L2.9,510.5 C0.9,521.7 -0.6,529 1.9,540.9 C0.4,562.8 3.7,596.3 5.1,618 C6.2,636 1.4,657.5 5.4,675.4 C23,674.7 43.2,677.3 60.6,676 C69.7,661.2 69.8,675.9 80.3,678.3 C121.3,678 162.7,681.3 203.7,681 C222.8,680 243.6,682.4 260.8,673.2 C265.1,666 270.6,677.6 276.4,679",
    id: "STROKE_5a14c768-71ca-49f7-80b7-4262c3836417_2_-Copy",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "HOLE",
    transform: "translate(71.404639, 269.164172)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5953614,0.235827664 C2.19536136,1.43582766 -5.70463864,16.0358277 5.49536136,27.6358277 C9.09536136,31.4358277 15.0953614,33.1358277 20.5953614,31.6358277 C20.9953614,31.5358277 29.0953614,29.2358277 31.6953614,21.0358277 C34.0953614,13.3358277 29.8953614,6.53582766 29.2953614,5.63582766 C25.2953614,0.535827664 17.5953614,-0.564172336 11.5953614,0.235827664 Z",
    id: "STROKE_ced4af17-0dfd-4790-b819-b26253c42bab_1_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7953614,9.53582766 C27.6953614,16.5358277 26.2953614,28.7358277 17.1953614,30.2358277 C14.1953614,30.8358277 7.99536136,30.6358277 5.49536136,27.7358277",
    id: "STROKE_2afa0b31-30d2-4122-877d-5a881188fc06"
  })), /*#__PURE__*/React.createElement("g", {
    id: "HOLE",
    transform: "translate(246.404639, 268.164172)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5953614,0.235827664 C2.19536136,1.43582766 -5.70463864,16.0358277 5.49536136,27.6358277 C9.09536136,31.4358277 15.0953614,33.1358277 20.5953614,31.6358277 C20.9953614,31.5358277 29.0953614,29.2358277 31.6953614,21.0358277 C34.0953614,13.3358277 29.8953614,6.53582766 29.2953614,5.63582766 C25.1953614,0.535827664 17.5953614,-0.564172336 11.5953614,0.235827664 Z",
    id: "STROKE_ced4af17-0dfd-4790-b819-b26253c42bab_2_"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6953614,9.53582766 C27.5953614,16.5358277 26.1953614,28.7358277 17.0953614,30.2358277 C14.0953614,30.8358277 7.89536136,30.6358277 5.39536136,27.7358277",
    id: "STROKE_2afa0b31-30d2-4122-877d-5a881188fc06_1_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "rope-1",
    transform: "translate(65.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2,226.4 L27.1,226.5 C48,251.4 33.1,303.6 9.6,277 C9.6,277 9.9,270.6 18,269.4 C19.3,269.2 22.1,264.7 22.1,264.7 C26,258.1 20.8,242.9 20.8,242.9 C20.8,242.9 17.3,234.8 14.7,231.8 C21.6,231.2 27.1,226.5 27.1,226.5",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "#A46832",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11.140625 C13.2666667,73.8950521 14.5333333,114.938932 13.8,134.272266 C13.0666667,153.605599 12.8666667,180.096514 13.2,213.745011 L28.1,212.745011 C27.4333333,153.563181 27.1,120.888932 27.1,114.722266 C27.1,105.472266 26.25,69.9722656 24.9,56.9722656 C24,48.305599 23.2666667,29.3148438 22.7,0 L10,11.140625 Z",
    id: "Path-2",
    fill: "#A46832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,202.2 C15.3,198.1 18.4,196.5 21.3,194.7",
    id: "STROKE_06914c45-0fb0-4d07-906f-913b4b3aa895",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,193.6 C16.1,191.1 17.7,190.2 20.2,188.6",
    id: "STROKE_5d51dc09-7309-4ad2-920b-757019014ea3_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,171.8 C14.6,170.6 17.3,168.5 18.5,167.7",
    id: "STROKE_fcee1bd3-2659-42dc-acdc-e9366ae0d20f",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,163.2 C15.3,160.8 17.8,158.8 19.8,158.3",
    id: "STROKE_c6f7b416-f20b-4857-8975-984c9d3fb2ae",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,154.6 C15.8,151.5 17.7,150.5 19.6,149.5",
    id: "STROKE_69492fa1-09ad-47cd-8955-2579ae1418fe_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,144.1 C15.1,141.5 15.8,140.6 19.3,139.7",
    id: "STROKE_932b4903-3ca7-4dba-a929-cabd42a89074",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,135.2 C14.8,132 17.1,128.6 19.9,129",
    id: "STROKE_ae963817-4493-48d5-8411-443b7b3acfce",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,123.9 C14.5,121.1 16.6,119.4 19.1,119.1",
    id: "STROKE_6d06e392-544d-45fa-8644-27dd27dd02d0",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,114.9 C15.7,112.5 16.7,110.6 20.7,109.9",
    id: "STROKE_8c1242e9-f789-47ab-b06b-7a869c0f81e6",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,104.8 C16.8,102.7 18.5,100.7 20.8,99.6",
    id: "STROKE_668df3ba-90e5-43e7-ba7f-c9e9d11797de",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,97.6 C14.2,94.8 16.8,92.9 19.1,92",
    id: "STROKE_e64a5e69-49a1-4536-a987-54ef448c8165",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,88.6 C14.2,86.1 16.4,84.9 19.5,84.1",
    id: "STROKE_b96424d4-a83c-4d7e-ad86-e5ce0f0d2bcf",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,80.8 C12.7,77.9 15.8,74.9 18.5,74.4",
    id: "STROKE_17758c73-975e-4699-adfa-98a1e31c9360",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,71.7 C13.2,68.3 16.7,65.8 16.6,66",
    id: "STROKE_55191f4a-fd25-4da5-b9e6-54f4de6cf293",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,61.4 C13.6,57.9 15,57.4 17.8,56.1",
    id: "STROKE_a84d1cfc-db0c-4531-804a-31a8304794a4",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,52.4 C12.9,51.2 15.1,49.1 17.6,48.4",
    id: "STROKE_35d9bbf4-872f-4b39-ac8b-2eac85b0e8cb_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,45.5 C12.1,45.3 13.8,43.6 17.4,40.5",
    id: "STROKE_d4434864-84be-4f86-b9a7-85bfba642d7e",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,38 C12.1,37.8 13.8,36.1 17.4,33",
    id: "STROKE_d4434864-84be-4f86-b9a7-85bfba642d7e_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,26.7 C12.1,26.5 13.8,24.8 17.4,21.7",
    id: "STROKE_d4434864-84be-4f86-b9a7-85bfba642d7e_2_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,279.3 C24.9,296.1 38.8,279.6 37.1,255.1",
    id: "STROKE_3aecfefe-cf29-468d-bc78-80223b8a8eb5",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9,215.3 C12.3,209.5 12.7,208.9 12.9,203.5 C16,147.9 11.3,78.7 11.3,23",
    id: "STROKE_4029e0f8-672d-4c1f-b726-40415dc32d39_2_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,212.9 C26.9,209 27.2,76.6 22.6,22.9",
    id: "STROKE_443d5b99-4091-462f-9f37-db1fdbe8a7e2_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,251.2 C12.3,249.9 12.2,247.7 13.2,245.6 C15,241.8 18.4,241.7 18.8,239.2 C18.7,238.3 16.4,234.4 14.7,231.8 C12.9,232.7 10.5,231.8 9.9,231.2 C7.2,231.6 4.9,234.7 3.5,236.9 C3.2,237.3 -0.9,245.2 1.5,251 C4.8,251.2 8.3,251.6 12.5,251.2 Z",
    id: "STROKE_14ccada1-bc78-4c19-89f7-781687dcfdf7",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "#A46832",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1,224.9 C32,225.4 37.3,231.3 40.1,236.9 C44.3,245.2 43.7,253.1 43.3,256.2 C46.7,258.4 51.8,256.2 54.9,253.7 C55.6,243.7 56.4,230.1 48.4,223 C43.3,218.4 36,218.3 33.2,218.2 C31.3,218.1 29.7,218.3 28.6,218.4 C28.4,220.6 28.3,222.7 28.1,224.9 Z",
    id: "STROKE_504fa36a-7d68-4a75-95dc-1416e8969253_1_",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "#A46832",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,260.2 C27,259.6 29.3,257.4 30.2,256.1",
    id: "STROKE_c6ebeedf-01d3-4d4b-9dab-8852d2b633c8",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,252.3 C26.2,250.8 28.4,247.7 28.9,245.9",
    id: "STROKE_36202b98-06bc-4933-b161-0c1258a9a2f9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,244.2 C23.1,243.2 25,240.3 25.4,239.2",
    id: "STROKE_70413856-a37c-438e-ab0b-b87bca694405",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7,238.4 C21.4,237.1 22.2,234.3 22.7,233.4",
    id: "STROKE_5b63d481-6454-48a6-92a2-15e9b633553c",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,232.8 C10.1,235 10.8,238.2 12,240",
    id: "STROKE_d9232d3d-c013-4beb-8f54-c2c6315f9631",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,237 C5.7,240.6 7.1,242.6 9.9,244.5",
    id: "STROKE_d29d7edc-16a4-41d6-b8c2-7bd1a796576b",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,244.2 C3.3,245.3 5.7,246.8 7,247.4",
    id: "STROKE_8d1e4233-d7f6-4204-8cb2-17cb98e597cc",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,224 L36.9,224.1 C36.9,225.2 36.7,226.6 36.3,227.7",
    id: "STROKE_6cd3f162-a686-4c6d-bd6a-b3edc442e8cb",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,226.2 L41.9,226.2 C42.1,227.5 41.3,230.2 40.6,231.3",
    id: "STROKE_0e514cc9-a2a8-41ed-8a9f-962606e6d80d",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2,231.9 C47.8,234.8 47.1,235.4 44.5,237.9",
    id: "STROKE_bf237123-4e86-460e-a4c6-c925abffedd9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7,237.8 C51.7,240.7 48.3,244.3 45.9,245.3",
    id: "STROKE_d95185ff-f66b-495f-a4bd-3fad0af54728",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3,247.3 C50.9,249.2 47.1,251.1 45.6,251.1",
    id: "STROKE_9c626bbb-6cdd-407b-9249-57c45e72f322",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,210.8 C14.4,208 17.3,204.6 21,203.5",
    id: "STROKE_8b52e801-4c95-4207-a05a-c08e50bf16cc",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,232.7 C11.5,232.8 16.5,232.8 12.9,232.8 C12.9,232.8 13.1,232.7 13.1,232.7",
    id: "STROKE_e0983c35-3c91-417a-9325-bf1fe8c0e50c",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,181.9 C15.7,181 16.9,180.2 17.8,179.6",
    id: "STROKE_34e8bfec-f99f-4362-8797-667813f8f76f_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,269.4 C20.8,270 23.3,271.7 26.2,269.6",
    id: "STROKE_1e30c396-db8a-4916-95f5-26c2e62667f9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1,264.7 C24.3,265.1 28.4,265 29.9,263.8",
    id: "STROKE_381ac805-7853-4725-a615-10bbed8d6b78",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,272.3 C13.4,273.8 15.7,274.7 16.8,275.4",
    id: "STROKE_a3ad8ff4-45df-47ab-b5f8-b3e0977b2a12",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 213.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3,18.2 C3.3,18.5 5.3,19 9.4,17.8 C13.3,16.6 16,14.7 19.1,11.8 C19.4,8.9 19.7,2.1 18,0.7 C17.1,-5.55111512e-17 8.8,0.3 3.9,2.2 C-1.8,5.2 0,14.7 2.3,18.2",
    id: "STROKE_fbeb485c-061a-4e0c-88d9-78a55545cdea",
    fill: "#A46832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,9.9 C3.5,10.4 8.3,8.5 10.8,7.1",
    id: "STROKE_14187394-6047-45dd-8eed-bf1d5d0fe746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4,14 C5.5,15.8 11.9,11.7 11.9,11.8",
    id: "STROKE_5bff1d31-05b1-4a28-b9a0-659fda464e4b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "rope2",
    transform: "translate(240.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2,226.4 L27.1,226.5 C48,251.4 33.1,303.6 9.6,277 C9.6,277 9.9,270.6 18,269.4 C19.3,269.2 22.1,264.7 22.1,264.7 C26,258.1 20.8,242.9 20.8,242.9 C20.8,242.9 17.3,234.8 14.7,231.8 C21.6,231.2 27.1,226.5 27.1,226.5",
    id: "Path",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "#A46832",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10,11.140625 C13.2666667,73.8950521 14.5333333,114.938932 13.8,134.272266 C13.0666667,153.605599 12.8666667,180.096514 13.2,213.745011 L28.1,212.745011 C27.4333333,153.563181 27.1,120.888932 27.1,114.722266 C27.1,105.472266 26.25,69.9722656 24.9,56.9722656 C24,48.305599 23.2666667,29.3148438 22.7,0 L10,11.140625 Z",
    id: "Path-2",
    fill: "#A46832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,202.2 C15.3,198.1 18.4,196.5 21.3,194.7",
    id: "STROKE_06914c45-0fb0-4d07-906f-913b4b3aa895",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,193.6 C16.1,191.1 17.7,190.2 20.2,188.6",
    id: "STROKE_5d51dc09-7309-4ad2-920b-757019014ea3_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,171.8 C14.6,170.6 17.3,168.5 18.5,167.7",
    id: "STROKE_fcee1bd3-2659-42dc-acdc-e9366ae0d20f",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,163.2 C15.3,160.8 17.8,158.8 19.8,158.3",
    id: "STROKE_c6f7b416-f20b-4857-8975-984c9d3fb2ae",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,154.6 C15.8,151.5 17.7,150.5 19.6,149.5",
    id: "STROKE_69492fa1-09ad-47cd-8955-2579ae1418fe_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,144.1 C15.1,141.5 15.8,140.6 19.3,139.7",
    id: "STROKE_932b4903-3ca7-4dba-a929-cabd42a89074",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6,135.2 C14.8,132 17.1,128.6 19.9,129",
    id: "STROKE_ae963817-4493-48d5-8411-443b7b3acfce",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7,123.9 C14.5,121.1 16.6,119.4 19.1,119.1",
    id: "STROKE_6d06e392-544d-45fa-8644-27dd27dd02d0",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2,114.9 C15.7,112.5 16.7,110.6 20.7,109.9",
    id: "STROKE_8c1242e9-f789-47ab-b06b-7a869c0f81e6",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,104.8 C16.8,102.7 18.5,100.7 20.8,99.6",
    id: "STROKE_668df3ba-90e5-43e7-ba7f-c9e9d11797de",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,97.6 C14.2,94.8 16.8,92.9 19.1,92",
    id: "STROKE_e64a5e69-49a1-4536-a987-54ef448c8165",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8,88.6 C14.2,86.1 16.4,84.9 19.5,84.1",
    id: "STROKE_b96424d4-a83c-4d7e-ad86-e5ce0f0d2bcf",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,80.8 C12.7,77.9 15.8,74.9 18.5,74.4",
    id: "STROKE_17758c73-975e-4699-adfa-98a1e31c9360",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,71.7 C13.2,68.3 16.7,65.8 16.6,66",
    id: "STROKE_55191f4a-fd25-4da5-b9e6-54f4de6cf293",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,61.4 C13.6,57.9 15,57.4 17.8,56.1",
    id: "STROKE_a84d1cfc-db0c-4531-804a-31a8304794a4",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1,52.4 C12.9,51.2 15.1,49.1 17.6,48.4",
    id: "STROKE_35d9bbf4-872f-4b39-ac8b-2eac85b0e8cb_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,45.5 C12.1,45.3 13.8,43.6 17.4,40.5",
    id: "STROKE_d4434864-84be-4f86-b9a7-85bfba642d7e",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,38 C12.1,37.8 13.8,36.1 17.4,33",
    id: "STROKE_d4434864-84be-4f86-b9a7-85bfba642d7e_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3,26.7 C12.1,26.5 13.8,24.8 17.4,21.7",
    id: "STROKE_d4434864-84be-4f86-b9a7-85bfba642d7e_2_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7,279.3 C24.9,296.1 38.8,279.6 37.1,255.1",
    id: "STROKE_3aecfefe-cf29-468d-bc78-80223b8a8eb5",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9,215.3 C12.3,209.5 12.7,208.9 12.9,203.5 C16,147.9 11.3,78.7 11.3,23",
    id: "STROKE_4029e0f8-672d-4c1f-b726-40415dc32d39_2_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27,212.9 C26.9,209 27.2,76.6 22.6,22.9",
    id: "STROKE_443d5b99-4091-462f-9f37-db1fdbe8a7e2_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5,251.2 C12.3,249.9 12.2,247.7 13.2,245.6 C15,241.8 18.4,241.7 18.8,239.2 C18.7,238.3 16.4,234.4 14.7,231.8 C12.9,232.7 10.5,231.8 9.9,231.2 C7.2,231.6 4.9,234.7 3.5,236.9 C3.2,237.3 -0.9,245.2 1.5,251 C4.8,251.2 8.3,251.6 12.5,251.2 Z",
    id: "STROKE_14ccada1-bc78-4c19-89f7-781687dcfdf7",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "#A46832",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1,224.9 C32,225.4 37.3,231.3 40.1,236.9 C44.3,245.2 43.7,253.1 43.3,256.2 C46.7,258.4 51.8,256.2 54.9,253.7 C55.6,243.7 56.4,230.1 48.4,223 C43.3,218.4 36,218.3 33.2,218.2 C31.3,218.1 29.7,218.3 28.6,218.4 C28.4,220.6 28.3,222.7 28.1,224.9 Z",
    id: "STROKE_504fa36a-7d68-4a75-95dc-1416e8969253_1_",
    stroke: "#000000",
    strokeWidth: 3,
    fill: "#A46832",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,260.2 C27,259.6 29.3,257.4 30.2,256.1",
    id: "STROKE_c6ebeedf-01d3-4d4b-9dab-8852d2b633c8",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4,252.3 C26.2,250.8 28.4,247.7 28.9,245.9",
    id: "STROKE_36202b98-06bc-4933-b161-0c1258a9a2f9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,244.2 C23.1,243.2 25,240.3 25.4,239.2",
    id: "STROKE_70413856-a37c-438e-ab0b-b87bca694405",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7,238.4 C21.4,237.1 22.2,234.3 22.7,233.4",
    id: "STROKE_5b63d481-6454-48a6-92a2-15e9b633553c",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8,232.8 C10.1,235 10.8,238.2 12,240",
    id: "STROKE_d9232d3d-c013-4beb-8f54-c2c6315f9631",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.1,237 C5.7,240.6 7.1,242.6 9.9,244.5",
    id: "STROKE_d29d7edc-16a4-41d6-b8c2-7bd1a796576b",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5,244.2 C3.3,245.3 5.7,246.8 7,247.4",
    id: "STROKE_8d1e4233-d7f6-4204-8cb2-17cb98e597cc",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,224 L36.9,224.1 C36.9,225.2 36.7,226.6 36.3,227.7",
    id: "STROKE_6cd3f162-a686-4c6d-bd6a-b3edc442e8cb",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9,226.2 L41.9,226.2 C42.1,227.5 41.3,230.2 40.6,231.3",
    id: "STROKE_0e514cc9-a2a8-41ed-8a9f-962606e6d80d",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2,231.9 C47.8,234.8 47.1,235.4 44.5,237.9",
    id: "STROKE_bf237123-4e86-460e-a4c6-c925abffedd9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7,237.8 C51.7,240.7 48.3,244.3 45.9,245.3",
    id: "STROKE_d95185ff-f66b-495f-a4bd-3fad0af54728",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.3,247.3 C50.9,249.2 47.1,251.1 45.6,251.1",
    id: "STROKE_9c626bbb-6cdd-407b-9249-57c45e72f322",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6,210.8 C14.4,208 17.3,204.6 21,203.5",
    id: "STROKE_8b52e801-4c95-4207-a05a-c08e50bf16cc",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4,232.7 C11.5,232.8 16.5,232.8 12.9,232.8 C12.9,232.8 13.1,232.7 13.1,232.7",
    id: "STROKE_e0983c35-3c91-417a-9325-bf1fe8c0e50c",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,181.9 C15.7,181 16.9,180.2 17.8,179.6",
    id: "STROKE_34e8bfec-f99f-4362-8797-667813f8f76f_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,269.4 C20.8,270 23.3,271.7 26.2,269.6",
    id: "STROKE_1e30c396-db8a-4916-95f5-26c2e62667f9",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1,264.7 C24.3,265.1 28.4,265 29.9,263.8",
    id: "STROKE_381ac805-7853-4725-a615-10bbed8d6b78",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1,272.3 C13.4,273.8 15.7,274.7 16.8,275.4",
    id: "STROKE_a3ad8ff4-45df-47ab-b5f8-b3e0977b2a12",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(9.000000, 213.000000)",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.3,18.2 C3.3,18.5 5.3,19 9.4,17.8 C13.3,16.6 16,14.7 19.1,11.8 C19.4,8.9 19.7,2.1 18,0.7 C17.1,-5.55111512e-17 8.8,0.3 3.9,2.2 C-1.8,5.2 0,14.7 2.3,18.2",
    id: "STROKE_fbeb485c-061a-4e0c-88d9-78a55545cdea",
    fill: "#A46832"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,9.9 C3.5,10.4 8.3,8.5 10.8,7.1",
    id: "STROKE_14187394-6047-45dd-8eed-bf1d5d0fe746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.4,14 C5.5,15.8 11.9,11.7 11.9,11.8",
    id: "STROKE_5bff1d31-05b1-4a28-b9a0-659fda464e4b"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "parchment",
    transform: "translate(3.000000, 257.000000)",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.9,3.1 C318.9,3.1 318.8,2.3 319,2.1",
    id: "STROKE_3f86fb41-0989-437e-bd9e-4fbb8e1eacf5",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.4,6.7 C330.1,6.6 329.9,6.4 329.8,6",
    id: "STROKE_5a7d4ecb-0415-4669-befe-a8f2975c210d",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327,0.7 C326.4,0.6 326.7,0.7 326.7,0.4",
    id: "STROKE_bfba6c49-6b8f-4f4f-8b97-6511ad7b144b",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.7,3.8 C336.6,3.8 336.6,6.8 334.7,6.8 C332.7,6.8 332.7,3.7 334.7,3.8 Z",
    id: "STROKE_be82f91d-3a8a-43c3-9c98-351fff68b969",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.5,23 C336.1,22.7 336,22.3 335.8,21.7",
    id: "STROKE_cec79a7f-b9a5-4b04-a3bf-f0ab03bd889c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.2,22.7 C324.1,22.7 324.1,25.7 322.2,25.7 C320.3,25.8 320.3,22.7 322.2,22.7 Z",
    id: "STROKE_819c0f36-f3c3-49a7-b0d0-b952c0989b49",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.2,396.1 C346.1,396.1 346.1,399.1 344.2,399.1 C342.3,399.1 342.3,396.1 344.2,396.1 Z",
    id: "STROKE_ceb7d48d-c483-4813-97e9-f8e03309e587",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.4,409.8 C337.6,409.4 337,409.6 335.5,410.5",
    id: "STROKE_95f612dc-73c8-4fb9-96af-7882129e6bc3",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.2,417.3 C335.9,417.2 337,417 337.5,417",
    id: "STROKE_7ff3a5fc-8c8e-4e51-bf87-d32f59c76098",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.6,413.8 C352.5,413.8 352.5,416.8 350.6,416.8 C348.7,416.9 348.7,413.8 350.6,413.8 Z",
    id: "STROKE_39355598-58dd-40bb-9ab4-bb5b15f6c389",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.3,409.1 C304,409.3 303.1,421.8 303.1,422",
    id: "STROKE_1e7256ed-f844-4282-b1d6-560eefaa9c4d",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.7,412.5 C310,414.9 308.6,419.2 308.5,422.8",
    id: "STROKE_610931a6-0320-4018-b01d-c6e98994a8e0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1,405.1 C14,404.7 13.9,404.8 14.3,404.5",
    id: "STROKE_7b50ad7d-91ca-4783-83c2-86454745928c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6,396.3 C22.5,396.3 22.5,399.3 20.6,399.3 C18.7,399.4 18.7,396.3 20.6,396.3 Z",
    id: "STROKE_33065178-6c91-445e-8a21-e27a6a56caa2",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2,403.3 C29.1,403.3 29.1,406.3 27.2,406.3 C25.3,406.3 25.3,403.3 27.2,403.3 Z",
    id: "STROKE_982d5e03-18dd-4ce9-a61f-a046e5f73e4c",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,409.3 C40.9,409.3 40.9,412.3 39,412.3 C37.1,412.3 37.1,409.2 39,409.3 Z",
    id: "STROKE_96ee219d-8406-456a-8d3a-2c8951e7944e",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,408.3 C23.4,408.3 23.4,411.3 21.5,411.3 C19.6,411.4 19.6,408.3 21.5,408.3 Z",
    id: "STROKE_7803f2da-8ef6-474e-81d5-e25fd60a7889",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2,376.5 C25.1,376.5 25.1,379.5 23.2,379.5 C21.2,379.5 21.2,376.4 23.2,376.5 Z",
    id: "STROKE_cfad62f2-a8e5-4ac0-87a5-81c85484f70e",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.2,337.5 C4.6,333.3 8.7,331.8 12.3,330.6",
    id: "STROKE_3d8bbe91-8563-41b3-b797-50a89438aff8",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,327 C3.6,324.7 6.6,323.3 9,321.9",
    id: "STROKE_9d7b7e48-c3cd-40a9-9d4f-7f3b6c5b71c7",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.3,312.3 C8.3,311.7 10.8,310.2 15.8,307.7",
    id: "STROKE_0f9e753a-36eb-482b-aefb-fbde924c1d45_1_",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3,292 C4.4,292.1 8.5,290.5 8.7,290.5",
    id: "STROKE_bf481eef-db3a-4a01-8c82-f26d9f8b9d32",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7,205 C4.6,205 4.2,205.2 3.3,205.5 C3.8,205 9.1,204 9.8,203.7",
    id: "STROKE_9a9e5e92-5835-4b39-a0ff-6835889ca97c",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.6,189.8 C2.1,188 8.5,186.7 10.2,186.4",
    id: "STROKE_8d79240b-d334-4246-9d14-5494cf49bea1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3,98.4 L11,97.9 C12.7,96.2 17.5,94.7 19.8,94.2",
    id: "STROKE_d53a697b-d3ce-4fd0-b51d-9a32c13a33b0",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8,106.1 C11.8,104.2 14.5,103.5 17.1,102.7",
    id: "STROKE_7804c72f-d38e-4122-b5d2-96753e80c117",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2,83.3 C12.9,81.3 16.4,79.8 18.9,78.6",
    id: "STROKE_0492ddcf-b137-435b-aa08-c1109dbf33de",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14,7.8 C14,7.8 13.9,7.8 13.6,8 C13.6,8 13.7,8 13.8,8",
    id: "STROKE_762b5cde-5ec2-4069-a049-70f2e63e6108",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2,17.7 C18,17.7 18,17.8 18.3,17.8",
    id: "STROKE_e5084bad-5d70-446e-bb6f-fa0cc0c538ce",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7,13.5 C30.5,12.7 30.5,13 30.8,11.6",
    id: "STROKE_ec5a9f49-27e6-4c98-aa56-d4de3b80b940",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6,7.6 C22.6,7.6 22.3,7.9 21.6,8.5 L21.6,8.7",
    id: "STROKE_bddf2522-b66d-4479-9eb8-7a5490b14f05",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9,4.7 C21.4,4.9 22.3,4.1 22.7,3.9",
    id: "STROKE_b343cb98-d5ab-4e94-9bf2-6d80483b6981",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3,53.3 C14,52.1 14.1,51.9 14.2,50.8",
    id: "STROKE_9d84b824-f5d3-475f-82d6-87caf3c90134",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1,66.8 L22.8,66.5 C22.7,66.1 22.8,65.7 22.8,65.3",
    id: "STROKE_1b951dee-c63f-4e5b-8866-e1904d780da1",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3,67.1 C18.2,67.1 17.8,67.4 17.2,68.1 C17.3,68.1 17.4,67.9 17.5,67.7",
    id: "STROKE_8240dc4d-cf19-4b40-81e4-ca8237d524ca",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.7,52.8 C332.1,52.2 332.3,51.9 332.3,51.9 C332.8,50.7 338.5,51.8 339.2,52",
    id: "STROKE_1c59aea3-76bb-4197-b0ca-02f5ae98a4cf",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.2,59.9 C332.5,59.3 339.8,57.8 340.3,57.6",
    id: "STROKE_89f23d69-38ef-4f6e-8068-934eed08c90b",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.7,84.7 C330.5,84 338.5,83.7 339.5,83.7",
    id: "STROKE_75156d7b-249c-4bf8-be6f-ddc84eb64365",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.3,139.9 C334.5,139.2 337.2,138.9 342.9,137.7",
    id: "STROKE_8308917c-6ca9-44c2-a76f-0cbb9c51c238",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.2,321.9 C334.2,322.1 334.3,322.4 334.3,322.6",
    id: "STROKE_ca15be92-decb-4fdb-a13d-bb2a2a37d4d0_1_",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.9,331.4 C343,331.1 343.3,330.7 343.6,330.2",
    id: "STROKE_71fab1a3-38db-4f8d-8860-ea35547dee98",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.3,338.1 C337.7,338.4 336.9,339.2 336.7,339.8",
    id: "STROKE_13c8c07a-97a4-4ed3-9716-10747be75914",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.8,354 C345.7,354.1 345.3,354 345.2,354.2",
    id: "STROKE_c4c0b03e-d919-4573-8c7e-dcfa45758451",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4,402.7 C59.3,402.7 59.3,405.7 57.4,405.7 C55.5,405.7 55.5,402.7 57.4,402.7 Z",
    id: "STROKE_c43edb6f-854b-4550-bb24-027b2108d37a",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7,390.8 C39.6,390.8 39.6,393.8 37.7,393.8 C35.8,393.8 35.8,390.8 37.7,390.8 Z",
    id: "STROKE_548cbb74-bfb4-4b27-b5d3-521bbe1fddfd",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,398.7 C35,398.7 35,401.7 33.1,401.7 C31.2,401.7 31.2,398.7 33.1,398.7 Z",
    id: "STROKE_47a63958-1adf-409b-a139-a5895150f2fe",
    strokeWidth: 0.2,
    fill: "#000000",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M258.1,269 C260.9,269.6 263.4,271.3 266.3,269.2",
    id: "STROKE_1e30c396-db8a-4916-95f5-26c2e62667f9_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.2,264.3 C264.4,264.7 268.5,264.6 270,263.4",
    id: "STROKE_381ac805-7853-4725-a615-10bbed8d6b78_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.1,271.9 C253.4,273.4 255.7,274.3 256.8,275",
    id: "STROKE_a3ad8ff4-45df-47ab-b5f8-b3e0977b2a12_1_",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackParchment);
export default __webpack_public_path__ + "static/media/feedbackParchment.7784016d7c82184ff6891ae438961530.svg";
export { ForwardRef as ReactComponent };